import store from "../../../js/store";
import {Layer, LayerGeometry} from "../../document/model/layer";

export class GeometryProvider {
  static async fetchSingleGeometry(geometryId, layer, accessToken) {
    let geometry = undefined;
    await store.dispatch(
      "getGeometryId",
      {
        data: {geometryId, documentId: layer.documentId, asFeature: true},
        headers: {
          "x-access-token": accessToken
        }
      }
    )
      .then((result) => {
        geometry = {
          ...result,
          geometry: result.geometry,
          document: layer
        };
      })
      .catch(error => {
        //todo: toast with error
      });

    return geometry;
  }

    static async fetchGeometries(geometries, layerMap, accessToken) {
        let fetchedGeometries = [];
        await store.dispatch(
            "getGeometries",
            {
              data: {
                geometries: geometries,
                asFeature: true
              },
              headers: {
                "x-access-token": accessToken,
              }
            }
        ).then(results => {
            fetchedGeometries = results.map(result => {
                return {
                    ...result,
                    geometry: {
                      ...result.geometry,
                      id: result?.geometry?.id || result.geometryId,
                    },
                    attributes: result.attributes,
                    document: layerMap.get(result.documentId)
                };
            });
        });

    return fetchedGeometries;
  }

  static async fetchLayerGeometries(layer: Layer, moduleId: string, accessToken?: any): Promise<LayerGeometry[]> {
    let geometries = [];

    await store.dispatch(
      "getLayerGeometries",
      {
        data: {
          documentId: layer.documentId,
          moduleId: moduleId,
          onlyGeometries: "true",
          query: []
        },
        headers: {
          "x-access-token": accessToken,
        }
      }
    ).then(results => {
      geometries = results.map(result => {
        return {
          ...result,
          document: layer
        }
      });
    });

    return geometries;
  }

  static async fetchIntersectedGeometries(geometryIds, layerMap, options?) {
    let fetchedGeometries = [];
    let payload = {
      data: {
        geometryIds: geometryIds,
        asFeature: true,
        ...(options ? options : {})
      },
      headers: {}
    }

    if(options['x-access-token']){
      payload.headers = {
        "x-access-token": options['x-access-token'],
      }
      delete options['x-access-token'];
    }
    await store.dispatch("getIntersectedGeometries", payload).then(results => {
      fetchedGeometries = results?.filter(x=> layerMap?.has(x.documentId))?.map(result => {
        return {
          ...result,
          attributes: result.attributes,
          geometry: result.geometry,
          document: layerMap?.get(result.documentId)
        };
      });
    });
    return fetchedGeometries;
  }

  static async fetchIsochrone(params, accessToken) {
        return await store.dispatch(
            "getIsochrone",
            {data: {"x-access-token": accessToken, ...params, asFeature: true}}
        )
  }
}
